'use strict';

const ContactUIStore = require('../stores/ContactUIStore');
const ContactMessageStore = require('../stores/ContactMessageStore');
const UserToUserMessageStore = require('../../userToUser/stores/UserToUserMessageStore.es');
const ContactGaStore = require('../stores/ContactGaStore');
const ContactTransactionStore = require('../stores/ContactTransactionStore');

/**
 * Registers the contact stores with the specified component.
 * @param App {Fluxible} A top level component that will be connected to the stores.
 * @param options {Object}
 * @param options.isStorefront {boolean} true if function is being called on dealer storefront
 */
module.exports = (App, options = {}) => {
    App.registerStore(ContactUIStore);
    App.registerStore(ContactMessageStore);
    App.registerStore(ContactGaStore);
    if (options.isUserToUser) {
        App.registerStore(UserToUserMessageStore);
    }
    if (!options.isStorefront) {
        App.registerStore(ContactTransactionStore);
    }
    return App;
};



// WEBPACK FOOTER //
// ./assets/js/contact/shared/helpers/connectToContact.es.js